export namespace ImageListUtils {
  // assumption: all words with images have small filenames, but might not have large ones
  const wordToSmallFilenames: any = {};
  const wordToLargeFilenames: any = {};

  export function getSmallImageFilenamesForWord(
    word: string
  ): string[] | undefined {
    return wordToSmallFilenames[word.toLowerCase()];
  }

  export function getLargeImageFilenameForWord(
    word: string
  ): string[] | undefined {
    return wordToLargeFilenames[word.toLowerCase()];
  }

  function addFilenameToWord(word: string, filename: string, list: any) {
    word = word.toLowerCase();

    if (!list[word]) {
      list[word] = [];
    }
    list[word].push(filename);
  }

  export function addSmallFilenameForWord(word: string, filename: string) {
    addFilenameToWord(word, filename, wordToSmallFilenames);
  }

  export function addLargeFilenameForWord(word: string, filename: string) {
    addFilenameToWord(word, filename, wordToLargeFilenames);
  }
}



// WEBPACK FOOTER //
// ./services/image/ImageListUtils.ts